import { BaseService, STATUS_OK, SuccessResponse } from "@/core/services/BaseService"

class UploadService extends BaseService {


  public async upload(data: FormData): Promise<string> {
    const res = await this.$http
      .post<SuccessResponse>(`/api/admin/upload`, data)
      .catch(error => error.response)

    return res.status === STATUS_OK ? res.data.message : '';
  }
}

export default new UploadService()
